import * as THREE from "three";
import {
  SITE_ORIENTATION_AXES_NAME,
  SITE_ORIENTATION_UP_ARROW_NAME,
} from "../selected-site-visibility/visibilityEvents";

function setOverlayMaterial(obj) {
  if (obj && obj.material) {
    const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
    mats.forEach((m) => {
      if (!m) return;
      m.depthTest = false;
      m.depthWrite = false;
      m.transparent = true;
      m.opacity = 1.0;
      m.toneMapped = false;
      m.fog = false;
    });
  }
}

/**
 * Remove orientation overlay children from a site group (if present).
 * @param {THREE.Object3D} siteGroup
 */
export function removeSiteOrientationAxes(siteGroup) {
  if (!siteGroup) return;
  const axes = siteGroup.getObjectByName(SITE_ORIENTATION_AXES_NAME);
  if (axes) siteGroup.remove(axes);
  const up = siteGroup.getObjectByName(SITE_ORIENTATION_UP_ARROW_NAME);
  if (up) siteGroup.remove(up);
}

/**
 * Add RGB axes + yellow +Z arrow under the site group (viewer overlay style).
 * @param {THREE.Object3D} siteGroup
 */
export function addSiteOrientationAxes(siteGroup) {
  if (!siteGroup) return;
  removeSiteOrientationAxes(siteGroup);
  const size = 0.06;
  const axes = new THREE.AxesHelper(size);
  axes.name = SITE_ORIENTATION_AXES_NAME;
  axes.renderOrder = 9999;
  setOverlayMaterial(axes);
  if (typeof axes.traverse === "function") axes.traverse(setOverlayMaterial);

  const dir = new THREE.Vector3(0, 0, 1);
  const origin = new THREE.Vector3(0, 0, 0);
  const length = size * 1.2;
  const headLength = size * 0.5;
  const headWidth = size * 0.3;
  const arrow = new THREE.ArrowHelper(dir, origin, length, 0xffff00, headLength, headWidth);
  arrow.name = SITE_ORIENTATION_UP_ARROW_NAME;
  arrow.renderOrder = 10000;
  setOverlayMaterial(arrow);
  if (typeof arrow.traverse === "function") arrow.traverse(setOverlayMaterial);

  siteGroup.add(arrow);
  siteGroup.add(axes);
}
